import { render, staticRenderFns } from "./OrderDefaultType.vue?vue&type=template&id=1acbe4d7&"
import script from "./OrderDefaultType.vue?vue&type=script&lang=js&"
export * from "./OrderDefaultType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports